import { storeConfig } from '@/shared/storeConfig';
function waitForSmartico(timeout = 15000, interval = 500) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const checkSmartico = () => {
      if (window && window._smartico && window._smartico.api) {
        resolve(true);
      } else if (Date.now() - startTime > timeout) {
        reject(new Error('Smartico API not available within timeout'));
      } else {
        setTimeout(checkSmartico, interval);
      }
    };

    checkSmartico();
  });
}

export const useSmarticoMessages = defineStore(
  'smarticoMessages',
  () => {
    const { debugLog } = useSmarticoConfigs();

    const isReadyMessages = ref<boolean>(false);
    const allInboxMessages = ref<TInboxMessage[]>([]);
    const unReadMessages = ref<number>(0);

    async function loadMessages() {
      try {
        isReadyMessages.value = false;

        await waitForSmartico(); // Aguarda a API Smartico estar pronta

        allInboxMessages.value = await window._smartico.api.getInboxMessages();

        unReadMessages.value = allInboxMessages.value.filter(
          (message) => !message.read,
        ).length;

        isReadyMessages.value = true;
      } catch (err: any) {
        isReadyMessages.value = false;

        debugLog(`⭕️ ~ getInboxMessages ~ ${err.toString()}`);
      }
    }

    async function loadSingleMessage(messageGuid: string) {
      try {
        return await window._smartico.api.getInboxMessageBody(messageGuid);
      } catch (err: any) {
        debugLog(`⭕️ ~ getInboxMessageBody ~ ${err.toString()}`);
      }
    }

    async function markNotificationAsRead(messageGuid: string) {
      try {
        return await window._smartico.api.markInboxMessageAsRead(messageGuid);
      } catch (err: any) {
        debugLog(`⭕️ ~ markInboxMessageAsRead ~ ${err.toString()}`);
      }
    }

    async function markAllInboxMessagesAsRead() {
      try {
        return await window._smartico.api.markAllInboxMessagesAsRead();
      } catch (err: any) {
        debugLog(`⭕️ ~ markAllInboxMessageAsRead ~ ${err.toString()}`);
      }
    }

    return {
      isReadyMessages,
      allInboxMessages,
      unReadMessages,
      loadMessages,
      loadSingleMessage,
      markNotificationAsRead,
      markAllInboxMessagesAsRead,
    };
  },

  storeConfig,
);
